// drawerStore.ts
import { create } from "zustand";

interface DrawerState {
  selectedSymbol: string | null;
  isOpen: boolean;
  setSelectedSymbol: (symbol: string | null) => void;
  closeDrawer: () => void;
}

const useDrawerStore = create<DrawerState>((set) => ({
  selectedSymbol: null,
  isOpen: false,
  setSelectedSymbol: (symbol) =>
    set({ selectedSymbol: symbol, isOpen: !!symbol }),
  closeDrawer: () => set({ selectedSymbol: null, isOpen: false }),
}));

export default useDrawerStore;
